import * as d3 from 'd3';
import { X } from 'lucide-react';
import { getIndicatorColor } from '../../utils/findicators/colors';

const fmt = d3.format('.2f');

// Picks a representative single number to show per indicator, whether its
// backend response is a flat array or a multi-key object.
const PRIMARY_KEY = {
  'Bollinger-Bands': 'middle_band',
  'Keltner-Channels': 'middle_band',
  MACD: 'macd',
  'Stochastic-Oscillator': 'stochastic_k',
  AROON: 'aroon_up',
  RVI: 'rvi',
  'Elder-Ray': 'bull_power',
  Ichimoku: 'conversion_line',
};

const getCurrentValue = (label, indicatorsData, index) => {
  const key = label.toLowerCase().replace(/-/g, '_');
  const values = indicatorsData?.[key];
  if (!values) return null;
  if (Array.isArray(values)) return values[index];
  const primary = PRIMARY_KEY[label];
  return primary ? values[primary]?.[index] : null;
};

const IndicatorLegend = ({ active, onChange, indicatorsData, data, hoveredBar }) => {
  if (!active || active.length === 0) return null;

  const bar = hoveredBar || data?.[data.length - 1];
  const index = bar ? data.findIndex((d) => d.date.getTime() === bar.date.getTime()) : -1;

  return (
    <div className="flex items-center gap-1.5 flex-wrap px-1">
      {active.map((label) => {
        const value = index >= 0 ? getCurrentValue(label, indicatorsData, index) : null;
        return (
          <div
            key={label}
            className="flex items-center gap-1.5 pl-2 pr-1 py-1 rounded-md bg-gray-100 dark:bg-white/[0.03] border border-gray-200 dark:border-white/[0.06] text-[11px]"
          >
            <span className="w-1.5 h-1.5 rounded-full" style={{ background: getIndicatorColor(label) }} />
            <span className="text-gray-600 dark:text-white/60">{label.replace(/-/g, ' ')}</span>
            {typeof value === 'number' && !isNaN(value) && (
              <span className="text-gray-400 dark:text-white/40" style={{ fontVariantNumeric: 'tabular-nums' }}>
                {fmt(value)}
              </span>
            )}
            <button
              type="button"
              onClick={() => onChange(active.filter((l) => l !== label))}
              className="p-0.5 rounded text-gray-400 hover:text-gray-700 hover:bg-gray-200 dark:text-white/25 dark:hover:text-white/70 dark:hover:bg-white/10 transition-colors"
              aria-label={`Remove ${label}`}
            >
              <X size={10} />
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default IndicatorLegend;
